import axios from "core/axios";

export default {
  createPayment: (amount: number) => {
    return axios.put(
      `/payment/createPaymentCloudpayments?idTopUpAmount=${amount}`,
      {},
      {
        headers: {
          Authorization: `Bearer ${window.localStorage.accessToken}`,
        },
      }
    );
  },
  getBalance: () => {
    return axios.get(`/payment/getVelvetEntitlement`, {
      headers: {
        Authorization: `Bearer ${window.localStorage.accessToken}`,
      },
    });
  },
  getVelvetEntitlement: () => {
    return axios.get(`/payment/getVelvetEntitlement`, {
      headers: {
        Authorization: `Bearer ${window.localStorage.accessToken}`,
      },
    });
  },
  // Каталог Velvet (планы Basic/Prime, фичи, офферы с offerId/appleProductId и ценами).
  // Задел под веб-платёжки: offerId пойдёт в платёжную ручку, когда её прикрутят.
  getVelvetCatalog: (locale: string) => {
    return axios.get(`/payment/getVelvetCatalog?locale=${locale}`, {
      headers: {
        Authorization: `Bearer ${window.localStorage.accessToken}`,
      },
    });
  },
  getPremiumPriceList: () => {
    return axios.get(`/payment/getPremiumPriceList`, {
      headers: {
        Authorization: `Bearer ${window.localStorage.accessToken}`,
      },
    });
  },
  getBoostPriceList: () => {
    return axios.get(`/payment/getBoostPriceList`, {
      headers: {
        Authorization: `Bearer ${window.localStorage.accessToken}`,
      },
    });
  },
  getInvisiblePriceList: () => {
    return axios.get(`/payment/getInvisiblePriceList`, {
      headers: {
        Authorization: `Bearer ${window.localStorage.accessToken}`,
      },
    });
  },
  getOnlineFilterPriceList: () => {
    return axios.get(`/payment/getOnlineFilterPriceList`, {
      headers: {
        Authorization: `Bearer ${window.localStorage.accessToken}`,
      },
    });
  },
  getPinnedProfilePriceList: () => {
    return axios.get(`/payment/getPinnedProfilePriceList`, {
      headers: {
        Authorization: `Bearer ${window.localStorage.accessToken}`,
      },
    });
  },
  buyPremium: (id: number) => {
    return axios.put(`/payment/buyPremium?idPremium=${id}`, {}, {
        headers: {
          Authorization: `Bearer ${window.localStorage.accessToken}`,
        },
      });
  },
  buyUp: (id: number) => {
    return axios.put(`/payment/buyBoost?idBoost=${id}`, {}, {
        headers: {
          Authorization: `Bearer ${window.localStorage.accessToken}`,
        },
      });
  },
  buyTop: (id: number) => {
    return axios.put(`/payment/buyPinnedProfile?idPinnedProfile=${id}`, {}, {
        headers: {
          Authorization: `Bearer ${window.localStorage.accessToken}`,
        },
      });
  },
  buyOnline: (id: number) => {
    return axios.put(`/payment/buyOnlineFilter?idOnlineFilter=${id}`, {}, {
        headers: {
          Authorization: `Bearer ${window.localStorage.accessToken}`,
        },
      });
  },
  buyHidden: (id: number) => {
    return axios.put(`/payment/buyInvisible?idInvisible=${id}`, {}, {
        headers: {
          Authorization: `Bearer ${window.localStorage.accessToken}`,
        },
      });
  },
  getBillingAmounts: () => {
    return axios.get(`/payment/getTopUpAmounts`, {
      headers: {
        Authorization: `Bearer ${window.localStorage.accessToken}`,
      },
    })
  }, 
  useBoost: () => {
    return axios.put(`/payment/useBoost`, {}, {
      headers: {
        Authorization: `Bearer ${window.localStorage.accessToken}`,
      },
    })
  },
};
